import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { get, ref, set } from "firebase/database";
import { databaseOrders, databaseStats } from "../firebase";
import { Button } from "primereact/button";

function StatsPage() {
    const doesStatsLoaded = useRef(false);
    const [isAvailable, setIsAvailable] = useState(false);
    const [reload, setReload] = useState(false);
    const [products, setProducts] = useState([]);
    const [orders, setOrders] = useState([]);
    const [orderCodes, setOrderCodes] = useState([]);
    const [password, setPassword] = useState("");
    const [activeTab, setActiveTab] = useState("orders");

    useLayoutEffect(() => {
        document.body.style.backgroundColor = "#0f0f0f";
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    useEffect(() => {
        if (isAvailable && !doesStatsLoaded.current) {
            const statsRef = ref(databaseStats, `/stats`);
            const ordersRef = ref(databaseOrders, "/orders");

            get(statsRef)
                .then((snapshot) => {
                    if (snapshot.exists()) {
                        setProducts(snapshot.val());
                    } else {
                        setProducts([]);
                    }
                })
                .catch((error) => console.error(error));

            get(ordersRef)
                .then((snapshot) => {
                    if (snapshot.exists()) {
                        setOrders(Object.values(snapshot.val()));
                        setOrderCodes(Object.keys(snapshot.val()));
                    } else {
                        setOrders([]);
                        setOrderCodes([]);
                    }
                })
                .catch((error) => console.error(error));

            doesStatsLoaded.current = true;
        }
    }, [isAvailable, reload]);

    const toggleIsHandled = (object, result, index) => {
        const updatedObject = { ...object, isHandled: result };
        replaceFirebaseObjectRTDB([...orderCodes].reverse()[index], updatedObject);
    };

    const replaceFirebaseObjectRTDB = async (objectKey, newObjectData) => {
        try {
            const objectRef = ref(databaseOrders, `orders/${objectKey}`);
            await set(objectRef, newObjectData);
            doesStatsLoaded.current = false;
            setReload(!reload);
        } catch (error) {
            console.error(`Error updating order ${objectKey}:`, error);
        }
    };

    const resetStats = async () => {
        if (!window.confirm("Ви впевнені, що хочете скинути статистику?")) {
            return;
        }
        try {
            const statsRef = ref(databaseStats, `/stats`);
            await set(statsRef, {
                homePage: 0,
                catalogPage: 0,
                airGoldPage: 0,
                diamondsPage: 0,
                billionPage: 0,
                errorPage: 0,
                koloroviPage: 0,
                vidrodzhennyaPage: 0,
                harmonyPage: 0,
                reflectPage: 0,
                exchangePage: 0,
                aboutUsPage: 0,
                deliveryPage: 0,
                luxuryPage: 0,
            });
            doesStatsLoaded.current = false;
            setReload(!reload);
        } catch (error) {
            console.error("Error resetting stats:", error);
        }
    };

    const {
        homePage = 0,
        catalogPage = 0,
        airGoldPage = 0,
        diamondsPage = 0,
        billionPage = 0,
        errorPage = 0,
        koloroviPage = 0,
        vidrodzhennyaPage = 0,
        harmonyPage = 0,
        reflectPage = 0,
        exchangePage = 0,
        aboutUsPage = 0,
        deliveryPage = 0,
        luxuryPage = 0,
    } = products;

    const totalVisits =
        homePage + catalogPage + airGoldPage + diamondsPage + billionPage +
        koloroviPage + vidrodzhennyaPage + harmonyPage + reflectPage + exchangePage +
        aboutUsPage + deliveryPage + luxuryPage;

    const pendingOrders = orders.filter((o) => !o.isHandled).length;
    const completedOrders = orders.filter((o) => o.isHandled).length;

    const statsData = [
        { name: "Головна", value: homePage, icon: "pi-home" },
        { name: "Каталог", value: catalogPage, icon: "pi-th-large" },
        { name: "Air Gold", value: airGoldPage, icon: "pi-star" },
        { name: "Diamonds", value: diamondsPage, icon: "pi-sparkles" },
        { name: "Billion", value: billionPage, icon: "pi-dollar" },
        { name: "Kolorovi", value: koloroviPage, icon: "pi-palette" },
        { name: "Vidrodzhennya", value: vidrodzhennyaPage, icon: "pi-heart" },
        { name: "Harmony", value: harmonyPage, icon: "pi-sun" },
        { name: "Reflect", value: reflectPage, icon: "pi-eye" },
        { name: "Exchange", value: exchangePage, icon: "pi-sync" },
        { name: "Luxury", value: luxuryPage, icon: "pi-crown" },
        { name: "Про нас", value: aboutUsPage, icon: "pi-info-circle" },
        { name: "Доставка", value: deliveryPage, icon: "pi-truck" },
    ];

    // Login screen
    if (!isAvailable) {
        return (
            <div className="min-h-screen flex items-center justify-center p-4">
                <div className="bg-gradient-to-br from-gray-900 to-gray-800 p-8 rounded-2xl shadow-2xl w-full max-w-sm">
                    <div className="text-center mb-8">
                        <i className="pi pi-lock text-4xl text-yellow-500 mb-4" />
                        <h1 className="text-2xl font-light text-white">TSATSKY Admin</h1>
                        <p className="text-gray-400 text-sm mt-2">Enter password to continue</p>
                    </div>

                    <div className="space-y-4">
                        <input
                            className="w-full bg-gray-700/50 border border-gray-600 rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:border-yellow-500 transition-colors"
                            value="admin"
                            disabled
                        />
                        <input
                            className="w-full bg-gray-700/50 border border-gray-600 rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:border-yellow-500 transition-colors"
                            onChange={(e) => {
                                setPassword(e.target.value);
                                if (e.target.value === "tsatskyDiamonds2025") {
                                    setIsAvailable(true);
                                    setPassword("");
                                }
                            }}
                            type="password"
                            placeholder="Password"
                            value={password}
                        />
                    </div>
                </div>
            </div>
        );
    }

    // Dashboard
    return (
        <div className="min-h-screen text-white p-4 lg:p-6">
            {/* Header */}
            <div className="flex flex-col lg:flex-row lg:items-center justify-between mb-8 gap-4">
                <div>
                    <h1 className="text-3xl font-light">TSATSKY Dashboard</h1>
                    <p className="text-gray-400 mt-1">Analytics & Order Management</p>
                </div>
                <Button
                    label="Оновити"
                    icon="pi pi-refresh"
                    className="bg-yellow-500 hover:bg-yellow-600 text-black font-semibold px-6 py-3 rounded-lg border-none transition-colors"
                    onClick={() => {
                        doesStatsLoaded.current = false;
                        setReload(!reload);
                    }}
                />
            </div>

            {/* Summary Cards */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
                <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl p-4 lg:p-6">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-blue-200 text-sm">Всього візитів</p>
                            <p className="text-3xl font-bold mt-1">{totalVisits}</p>
                        </div>
                        <i className="pi pi-eye text-3xl text-blue-300 opacity-80" />
                    </div>
                </div>

                <div className="bg-gradient-to-br from-purple-600 to-purple-700 rounded-xl p-4 lg:p-6">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-purple-200 text-sm">Всього замовлень</p>
                            <p className="text-3xl font-bold mt-1">{orders.length}</p>
                        </div>
                        <i className="pi pi-shopping-bag text-3xl text-purple-300 opacity-80" />
                    </div>
                </div>

                <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl p-4 lg:p-6">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-orange-200 text-sm">Очікують</p>
                            <p className="text-3xl font-bold mt-1">{pendingOrders}</p>
                        </div>
                        <i className="pi pi-clock text-3xl text-orange-300 opacity-80" />
                    </div>
                </div>

                <div className="bg-gradient-to-br from-green-600 to-green-700 rounded-xl p-4 lg:p-6">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-green-200 text-sm">Оброблено</p>
                            <p className="text-3xl font-bold mt-1">{completedOrders}</p>
                        </div>
                        <i className="pi pi-check-circle text-3xl text-green-300 opacity-80" />
                    </div>
                </div>
            </div>

            {/* Tabs */}
            <div className="flex gap-2 mb-6">
                <button
                    onClick={() => setActiveTab("orders")}
                    className={`px-6 py-3 rounded-lg font-medium transition-colors ${
                        activeTab === "orders"
                            ? "bg-yellow-500 text-black"
                            : "bg-gray-800 text-gray-300 hover:bg-gray-700"
                    }`}
                >
                    <i className="pi pi-shopping-cart mr-2" />
                    Замовлення
                </button>
                <button
                    onClick={() => setActiveTab("stats")}
                    className={`px-6 py-3 rounded-lg font-medium transition-colors ${
                        activeTab === "stats"
                            ? "bg-yellow-500 text-black"
                            : "bg-gray-800 text-gray-300 hover:bg-gray-700"
                    }`}
                >
                    <i className="pi pi-chart-bar mr-2" />
                    Статистика
                </button>
            </div>

            {/* Stats Tab */}
            {activeTab === "stats" && (
                <div>
                    <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
                        {statsData.map((stat) => (
                            <div
                                key={stat.name}
                                className="bg-gray-800/50 border border-gray-700 rounded-xl p-4 hover:border-yellow-500/50 transition-colors"
                            >
                                <div className="flex items-center gap-3 mb-3">
                                    <i className={`pi ${stat.icon} text-yellow-500`} />
                                    <span className="text-gray-400 text-sm">{stat.name}</span>
                                </div>
                                <p className="text-2xl font-bold">{stat.value || 0}</p>
                            </div>
                        ))}

                        {errorPage > 0 && (
                            <div className="bg-red-900/30 border border-red-700 rounded-xl p-4">
                                <div className="flex items-center gap-3 mb-3">
                                    <i className="pi pi-exclamation-triangle text-red-500" />
                                    <span className="text-red-400 text-sm">Errors</span>
                                </div>
                                <p className="text-2xl font-bold text-red-400">{errorPage}</p>
                            </div>
                        )}
                    </div>

                    <button
                        onClick={resetStats}
                        className="px-6 py-3 rounded-lg font-medium bg-gray-800 text-gray-300 hover:bg-red-600 hover:text-white transition-colors flex items-center gap-2"
                    >
                        <i className="pi pi-trash" />
                        Скинути статистику
                    </button>
                </div>
            )}

            {/* Orders Tab */}
            {activeTab === "orders" && (
                <div className="space-y-4">
                    {orders.length === 0 ? (
                        <div className="text-center py-16 text-gray-400">
                            <i className="pi pi-inbox text-5xl mb-4 opacity-50" />
                            <p>Замовлень поки немає</p>
                        </div>
                    ) : (
                        [...orders].reverse().map((order, index) => {
                            const { name, phoneNumber, product, products, date, isHandled } = order;
                            const orderProducts = products || (product ? [product] : []);
                            return (
                                <div
                                    key={index}
                                    className={`bg-gray-800/50 border border-gray-700 rounded-xl overflow-hidden ${
                                        !isHandled ? "ring-1 ring-yellow-500/30" : ""
                                    }`}
                                >
                                    {/* Order Header */}
                                    <div className="px-4 py-3 flex items-center justify-between bg-gray-800">
                                        <div className="flex items-center gap-3">
                                            <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                                                isHandled
                                                    ? "bg-green-500/20 text-green-400"
                                                    : "bg-yellow-500/20 text-yellow-400"
                                            }`}>
                                                {isHandled ? "Оброблено" : "Очікує"}
                                            </span>
                                            <span className="text-gray-400 text-sm">{date}</span>
                                        </div>
                                    </div>

                                    {/* Order Body */}
                                    <div className="p-4">
                                        {/* Customer Info */}
                                        <div className="flex flex-col lg:flex-row lg:items-center gap-4 mb-4 pb-4 border-b border-gray-700">
                                            <div className="flex items-center gap-3">
                                                <i className="pi pi-user text-gray-500" />
                                                <span>{name || "—"}</span>
                                            </div>
                                            <div className="flex items-center gap-3">
                                                <i className="pi pi-phone text-gray-500" />
                                                <a
                                                    href={`tel:${phoneNumber}`}
                                                    className="text-gray-300 hover:text-white transition-colors"
                                                >
                                                    {phoneNumber}
                                                </a>
                                            </div>
                                        </div>

                                        {/* Products */}
                                        <div className="space-y-3 mb-4">
                                            {orderProducts.map((p, pIndex) => (
                                                <div
                                                    key={pIndex}
                                                    className="flex items-center gap-4 bg-gray-900/50 rounded-lg p-3"
                                                >
                                                    {p.image && (
                                                        <img
                                                            src={p.image}
                                                            alt={p.name}
                                                            className="w-16 h-16 object-cover rounded-lg"
                                                        />
                                                    )}
                                                    <div className="flex-1">
                                                        <p className="font-medium">{p.name}</p>
                                                        <p className="text-sm text-gray-500">
                                                            Артикул: {p.article}
                                                        </p>
                                                    </div>
                                                    {p.quantity > 1 && (
                                                        <p className="text-sm text-gray-500">
                                                            x{p.quantity}
                                                        </p>
                                                    )}
                                                </div>
                                            ))}
                                        </div>

                                        {/* Actions */}
                                        <div className="flex gap-3">
                                            <button
                                                onClick={() => toggleIsHandled(order, true, index)}
                                                className={`flex-1 py-3 rounded-lg font-medium transition-colors flex items-center justify-center gap-2 ${
                                                    isHandled
                                                        ? "bg-green-600 text-white"
                                                        : "bg-gray-700 text-gray-300 hover:bg-gray-600"
                                                }`}
                                            >
                                                <i className="pi pi-check" />
                                                Оброблено
                                            </button>
                                            <button
                                                onClick={() => toggleIsHandled(order, false, index)}
                                                className={`flex-1 py-3 rounded-lg font-medium transition-colors flex items-center justify-center gap-2 ${
                                                    !isHandled
                                                        ? "bg-yellow-500 text-black"
                                                        : "bg-gray-700 text-gray-300 hover:bg-gray-600"
                                                }`}
                                            >
                                                <i className="pi pi-clock" />
                                                Очікує
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>
            )}
        </div>
    );
}

export default StatsPage;
